import { useLocation } from 'react-router-dom';
import { crearWhatsAppUrl, contactoDeRuta } from '../utils/contactos';
import React, { useEffect, useState } from 'react';

const FloatingButtons = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <a
        href={crearWhatsAppUrl(contactoDeRuta(pathname))}
        className="float-whatsapp-corporate"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-whatsapp"></i>
        <span className="float-text">¿Necesitas ayuda?</span>
      </a>

      <button
        className={`float-top-corporate ${visible ? 'visible' : ''}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </>
  );
};

export default FloatingButtons;